<div class="setting-option mb-3 p-3">
  <!-- OSPR Changes- modifying h5 to h2-->
  <span><label for="{{id}}">{{label | translate}}</label></span>
  <!-- modified h5 to h2-->
  <select id="{{id}}" class="form-control" (change)="change.emit($event)">
    <ng-content></ng-content>
  </select>
</div>
